require('./bootstrap');
require('jquery-ujs');
require('./remote');
require('./sort-table.min');
require('./style');